module.exports = __webpack_public_path__ + "static/media/scroll3_4.08e3c2e8.png";